(function ($) {
  $(window).on('load resize', function () {
    if ($(window).width() >= 1024) {
      $('.why-us__wrapper .col').css('height', $('.why-us__wrapper .img-wrap').outerHeight(true));
    } else {
      $('.why-us__wrapper .col').removeAttr('style');
    }
  });
})(jQuery);